import { Commodity } from '../types/all';

import { Site } from './site.model';

export class SiteGroup {
  code: string;
  name: string;
  sites: Site[] = [];
  accountId: number;

  constructor(attributes: Partial<SiteGroup> = {}) {
    Object.assign(this, attributes);
  }

  /**
   * Returns the number of delivery points for every Sites of this SiteGroup.
   * Can be restricted to a single commodity.
   */
  getPointsCount(commodity?: Commodity): number {
    let total = 0;
    this.sites.forEach((site: Site) => {
      total += site.getPointsByCommodity(commodity).length;
    });

    return total;
  }

  get gasPointCount() {
    return this.getPointsCount(Commodity.gas);
  }

  get powerPointCount() {
    return this.getPointsCount(Commodity.power);
  }
}
